
export default function updateItemData(itemPurchaseData){
    let decorationStorePurchaseStore = app.store.data.decorationStorePurchase || {};
    let decorationStoreEquipmentStore = app.store.data.decorationStoreEquipment || {};
    const itemData = itemPurchaseData.decorationData();
    const purchaseID = itemPurchaseData.id();
    const itemType = itemPurchaseData.item_type();
    const purchaseDataStatus = itemPurchaseData.item_status();
    const itemProperty = JSON.parse(itemData.item_property());
    const itemPropertyImage = purchaseDataStatus===1?itemProperty.image:"";

    for(let index in decorationStorePurchaseStore){
      let decorationStorePurchaseStoreData = decorationStorePurchaseStore[index];
      const purchaseItemData = decorationStorePurchaseStoreData.decorationData();
      const purchaseItemType = purchaseItemData.item_type();

      if(decorationStorePurchaseStoreData.id()===purchaseID){
        decorationStorePurchaseStore[index].data.attributes.item_status = purchaseDataStatus;
      }else{
        if(purchaseItemType===itemType){
          decorationStorePurchaseStore[index].data.attributes.item_status = 0;
        }
      }
    }

    for(let index in decorationStoreEquipmentStore){
      let decorationStoreEquipmentStoreData = decorationStoreEquipmentStore[index];
      const equipmentItemType = decorationStoreEquipmentStoreData.item_type();

      if(equipmentItemType===itemType){
        delete decorationStoreEquipmentStore[index];
      }
    }

    if(itemPurchaseData.item_status()===1){
      decorationStoreEquipmentStore[purchaseID] = itemPurchaseData;
    }

    app.store.data.decorationStorePurchase = decorationStorePurchaseStore;
    app.store.data.decorationStoreEquipment = decorationStoreEquipmentStore;

    app.store.pushPayload(itemPurchaseData);

    let attributeName = "";
    if(itemType==="avatarFrame"){
      $(".decorationAvatarFrameImageSource").attr("src",itemPropertyImage);
      attributeName = "decorationAvatarFrame";

      if(itemPropertyImage===""){
        $(".UserCard-avatar .Avatar").css("background-clip","");
        $(".UserCard-avatar .Avatar").css("border","4px solid #fff");
      }else{
        $(".UserCard-avatar .Avatar").css("background-clip","padding-box");
        $(".UserCard-avatar .Avatar").css("border","4px solid rgba(0,0,0,0)");
        $(".UserCard-avatar .Avatar").css("box-shadow","none");
      }
    }else if(itemType==="profileBackground"){
      $("body").css("--decoration-profileBackground","url("+itemPropertyImage+")");
      attributeName = "decorationProfileBackground";
    }else if(itemType==="usernameColor"){
      $(".username").removeClass().addClass('username');
      $(".username").addClass(itemPropertyImage);
      attributeName = "decorationUsernameColor";
    }

    if(attributeName!==""){
      app.session.user.data.attributes[attributeName] = itemPropertyImage;
    }
    
    m.redraw();
}
